<template>
  <section class="whiteBox">
    <!-- HEAD  -->
    <div class="content">
      <h1 v-if="!this.$route.params.id">{{$t('createCampaign.title')}}</h1>
      <h1 v-else>{{$t('campaigns.modifyCampaignAction')}}</h1>
    </div>
    <div class="row">
      <div class="formBox accentuate blueSelect">{{$t('createCampaign.uniqueCoupon')}}</div>
    </div>
    <div class="row whiteBg">
      <i class="far fa-dot-circle blueColor"></i>
      <p class="tips blueColor">{{$t('createCampaign.generalDescription')}}</p>
      <div class="separator blueColor"></div>
      <i class="far fa-dot-circle blueColor"></i>
      <p class="tips blueColor">{{$t('createCampaign.couponDescription')}}</p>
      <div class="separator blueColor"></div>
      <i class="far fa-dot-circle blueColor"></i>
      <p class="tips">{{$t('createCampaign.associateProduct')}}</p>
    </div>
    <!-- CONTENT PRODUCT ASSOCIATE -->
    <div class="content">
      <p class="accentuate">{{$t('associateProduct.title')}}</p>
      <div class="spacer-10"></div>
      <label>{{$t('products.productName')}}</label>
      <span
        class="errorSentence"
        v-if="!isProductSelected&&isSubmitted"
      >&nbsp;{{$t('addDiscount.errorDiscountProduct')}}</span>
      <div class="row">
        <div class="demiRow">
          <select
            @change="changeCurrentProduct(currentDiscount['product-id'])"
            v-model="currentDiscount['product-id']"
            :class="{ 'error' : !isProductSelected&&isSubmitted}"
          >
            <option
              v-for="product in products"
              :key="product.id"
              :value="product.id"
            >{{product['sales-channel-name'] +' | '+ product.name}}</option>
          </select>
        </div>
        <p class="tips">{{$t('products.productNameTips')}}</p>
      </div>
      <div class="row">
        <p class="tips">{{$t('associateProduct.notFoundProduct')}}</p>
        <a @click="addProduct = true">{{$t('associateProduct.addProduct')}}</a>
        <AddProduct
          v-if="addProduct == true"
          @close="addProduct = false"
          @newproduct="addNewProduct()"
          @click="addProduct = true"
        ></AddProduct>
      </div>
      <div class="spacer-10"></div>
      <label>{{$t('associateProduct.promotionType')}}</label>
      <span
        class="errorSentence"
        v-if="!discountValueFormat&&isSubmitted&&currentDiscount['discount-type'] == 0 "
      >&nbsp;{{$t('manageSingleDiscount.errorDiscountValuePercentage')}}</span>
      <div class="row">
        <input
          type="radio"
          v-model="currentDiscount['discount-type']"
          value="0"
        >
        <label>{{$t('associateProduct.promotionInPercentage')}}</label>
        <div
          class="dataEndInput"
          v-if="currentDiscount['discount-type'] == 0 "
        >
          <p>%</p>
          <input
            type="number"
            min="0"
            max="100"
            :class="{ 'error' : !discountValueFormat&&isSubmitted ,'sInput':true}"
            v-model="currentDiscount['discount-value']"
          >
        </div>
      </div>
      <div class="row">
        <input
          type="radio"
          v-model="currentDiscount['discount-type']"
          value="1"
        >
        <label>{{$t('associateProduct.promotionInValue')}}</label>
        <div
          class="dataEndInput"
          v-if="currentDiscount['discount-type'] == 1"
        >
          <p>{{convertCurrencyToSymbol(currentDiscount['currency'])}}</p>
          <input
            type="number"
            min="0"
            max="100"
            class="sInput"
            v-model="currentDiscount['discount-value']"
          >
        </div>
      </div>
      <br>
      <label>{{$t('associateProduct.couponsDesc')}}</label>
      <div class="spacer-10"></div>
      <div class="row">
        <div
          @click="changeLang(item.lang)"
          class="sFormBox pointer"
          :class="{ blueSelect: currentLang == item.lang }"
          v-for="item in discountDescriptions"
          :key="item.lang"
        >{{item.lang}}</div>
        <div
          class="sFormBox pointer"
          @click="newLang = true"
        >{{$t('associateProduct.add')}}</div>
        <AddLang
          v-if="newLang"
          @close="newLang = false"
          @add="getNewLang"
        ></AddLang>
      </div>
      <div class="spacer-10"></div>
      <label>{{$t('associateProduct.couponDescField')}}</label>
      <span
        class="errorSentence"
        v-if="!frDescriptionFilled && isSubmitted"
      >* {{$t('error.textFieldRequired')}}</span>
      <div class="row alignCenter">
        <div class="demiRow">
          <textarea
            rows="3"
            v-model="discountDescriptions[currentLang].description"
            :class="{ 'error' : !frDescriptionFilled&&isSubmitted  }"
          ></textarea>
        </div>
        <p class="tips">{{$t('associateProduct.couponDescFieldTips')}}</p>
      </div>
      <div>
        <button
          v-if="!currentDiscountIsEditing"
          @click="addDiscountAssociate"
        >{{$t('button.associateThisDiscount')}}</button>
        <button
          v-else
          @click="addDiscountAssociate"
        >{{$t('button.modifyThisDiscount')}}</button>
      </div>
    </div>

    <hr>
    <div class="content">
      <button
        @click="changeCurrentProduct(disc['product-id'])"
        v-bind:class="{'dashedColorBlue': productInEdition(disc['product-id']),'dashedCreated':!productInEdition(disc['product-id']) }"
        v-for="disc in discountsAssociated"
        :key="disc['product-id']"
      >{{getProductById(disc["product-id"]).name}} | {{disc['discount-value']}} {{getDiscountType(disc['discount-type'])}}</button>
    </div>
    <hr>
    <div class="content">
      <div class="row">
        <button
          v-if="!this.$route.params.id"
          @click="next()"
        >{{$t('button.createTheCampaign')}}</button>
        <button
          v-else
          @click="next()"
        >{{$t('button.modifyTheCampaign')}}</button>
        <button
          @click="$emit('return');$emit('updatediscounts', discountsAssociated)"
          class="outline"
        >{{$t('button.back')}}</button>
        <a @click="goBack">{{$t('button.cancel')}}</a>
      </div>
    </div>
  </section>
</template>

<script>
import AddLang from "@/components/campaigns/manageCampaign/AddLang";
import AddProduct from "@/components/products/AddInBox";
import getProducts from "@/mixins/getProducts";
import Campaigns from "@/services/Campaigns";
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
import Discounts from "@/services/Discounts";
import DiscountDetails from "@/services/DiscountDetails";
import generalMethods from "@/mixins/generalMethods";
export default {
  props: ["parCampaign", "parGroupOfDiscounts"],
  mixins: [getProducts, generalMethods],
  components: { AddLang, AddProduct },
  data() {
    return {
      productSelected: [],
      currentLang: this.$t("lang.fr.title"),
      addProduct: false,
      newLang: false,
      currentDiscountIsEditing: false,
      isSubmitted: false,
      discountsAssociated: [],
      currentDiscount: {
        "product-id": "",
        "group-of-discounts-id": "",
        "discount-type": 0,
        "discount-value": "",
        "discount-currency": "EUR",
        "discount-details": {}
      },
      discountDescriptions: {}
    };
  },
  computed: {
    isProductSelected: function() {
      if (this.currentDiscount["product-id"]) return true;
      return false;
    },
    frDescriptionFilled: function() {
      if (this.discountDescriptions[this.$t("lang.fr.title")].description)
        return true;
      return false;
    },
    discountValueFormat: function() {
      // If not a number
      if (this.currentDiscount["discount-value"] == "") return false;
      //concert to number

      var value = parseFloat(this.currentDiscount["discount-value"]);
      //check percentage
      if (this.currentDiscount["discount-type"] == 0) {
        if (value <= 100 && value >= 0 && Number.isInteger(value)) return true;
        //check currency
      } else {
        if (value >= 0) return true;
      }
      return false;
    }
  },
  beforeMount() {
    this.initDiscountDetails();
  },
  mounted() {
    this.getProducts();
    this.initValues();
  },

  methods: {
    /************  UTILS ************/
    addNewProduct() {
      this.addProduct = false;
      this.getProducts();
    },
    productInEdition(id) {
      return id == this.currentDiscount["product-id"];
    },
    goBack() {
      if (this.parCampaign["status"] == 0)
        this.$router.push({
          name: "allCampaigns",
          params: { campaignType: "active" }
        });
      else
        this.$router.push({
          name: "detailUniqueCampaign",
          params: { id: this.$route.params.id }
        });
    },
    getDiscountType(type) {
      if (type == 0) {
        return "%";
      } else if (type == 1) {
        return "€";
      }
    },
    textFieldsValide() {
      this.isSubmitted = true;
      return (
        this.isProductSelected &&
        this.frDescriptionFilled &&
        this.discountValueFormat
      );
    },
    getProductById(productId) {
      var returnValue = this.products.find(x => x["id"] === productId);
      if (!returnValue) return "";
      return returnValue;
    },
    changeLang(data) {
      this.currentLang = data;
    },
    getNewLang(data) {
      this.newLang = false;
      if (data.lang.title) {
        /* We add the new lang or update an existing lang */
        this.discountDescriptions[data.lang.title] = {
          lang: data.lang.title,
          code: data.lang.code,
          description: data.description
        };
        this.currentLang = data.lang.title;
      }
    },
    //Init Discount Details to default language
    initDiscountDetails() {
      this.discountDescriptions = {
        Français: {
          lang: this.$t("lang.fr.title"),
          code: this.$t("lang.fr.code"),
          description: "",
          archived: false
        }
      };
      this.changeLang(this.discountDescriptions[this.$t("lang.fr.title")].lang);
    },
    //Init Values
    initValues() {
      //Check if value already init
      if (this.parGroupOfDiscounts.discountsList)
        this.discountsAssociated = this.parGroupOfDiscounts.discountsList;
      else {
        GroupsOfDiscounts.get(this.parCampaign.id).then(res => {
          if (res.status == 200) {
            if (res.data[0]) {
              this.parGroupOfDiscounts.id = res.data[0].id;
              Discounts.get(res.data[0].id).then(res => {
                if (res.status == 200) {
                  for (let i = 0; i < res.data.length; i++) {
                    this.discountsAssociated.push({
                      "product-id": res.data[i]["product-id"],
                      "group-of-discounts-id": this.parGroupOfDiscounts.id,
                      "discount-type": res.data[i]["discount-type"],
                      "discount-currency": res.data[i]["discount-currency"],
                      "discount-details": {
                        Français: {
                          lang: this.$t("lang.fr.title"),
                          code: this.$t("lang.fr.code"),
                          description: "",
                          archived: false
                        }
                      }
                    });
                    this.discountsAssociated[i]["discount-value"] =
                      res.data[i]["discount-type"] == 1
                        ? res.data[i]["discount-value"] / 100
                        : res.data[i]["discount-value"];
                    DiscountDetails.get(res.data[i].id).then(res => {
                      if (res.status == 200) {
                        var languages = Object.keys(this.$t("lang"));
                        for (var z = 0; z < languages.length; z++) {
                          var object = res.data.find(
                            x =>
                              x["language"] ==
                              this.$t("lang")[languages[z]].code
                          );
                          if (object) {
                            var currentLangTest = this.$t("lang")[languages[z]];
                            this.discountsAssociated[i]["discount-details"][
                              currentLangTest.title
                            ] = {
                              lang: currentLangTest.title,
                              code: currentLangTest.code,
                              description: object.description,
                              archived: false
                            };
                          }
                        }
                      }
                    });
                  }
                }
              });
            }
          }
        });
      }
    },
    //Discount associating
    addDiscountAssociate() {
      if (this.textFieldsValide()) {
        this.isSubmitted = false;
        this.currentDiscount["discount-details"] = this.discountDescriptions;
        var discountTempIndex = this.discountsAssociated.findIndex(
          x => x["product-id"] === this.currentDiscount["product-id"]
        );
        if (this.currentDiscount["product-id"] && discountTempIndex != -1) {
          this.discountsAssociated[discountTempIndex] = this.currentDiscount;
        } else if (this.currentDiscount["product-id"]) {
          this.discountsAssociated.push(this.currentDiscount);
        }

        this.currentDiscount = {
          "product-id": "",
          "group-of-discounts-id": "",
          "discount-type": 0,
          "discount-value": '',
          "discount-currency": "EUR",
          "discount-details": []
        };

        this.initDiscountDetails();

        this.currentDiscountIsEditing = false;
      }
    },
    //Switch between discounts associated
    changeCurrentProduct(id) {
      var productSelected = this.discountsAssociated.find(
        x => x["product-id"] == id
      );
      if (productSelected) {
        this.currentDiscountIsEditing = true;
        this.currentDiscount = productSelected;
        this.initDiscountDetails();
        this.discountDescriptions = this.currentDiscount["discount-details"];
        this.changeLang(
          this.discountDescriptions[this.$t("lang.fr.title")].lang
        );
      } else {
        this.currentDiscountIsEditing = false;
      }
    },
    //NEXT PAGE
    next() {
      if (this.discountsAssociated.length > 0) {
        this.parGroupOfDiscounts["discounts"] = this.discountsAssociated;
        if (!this.parGroupOfDiscounts.id) {
          this.insertNewGroupOfDiscount(
            this.parCampaign.id,
            this.parGroupOfDiscounts
          );
        } else {
          this.updateGroupOfDiscount(
            this.parCampaign.id,
            this.parGroupOfDiscounts
          );
        }
      } else {
        this.textFieldsValide();
      }
    },
    /************  DISCOUNTS ************/
    insertDiscount(groupOfDiscountId, discountObject) {
      Discounts.add(groupOfDiscountId, discountObject).then(res => {
        let locationSplit = res.headers.location.split("/");
        var newDiscountId = locationSplit[locationSplit.length - 1];
        var languages = Object.keys(discountObject["discount-details"]);
        for (var i = 0; i < languages.length; i++) {
          this.insertDiscountDetails(
            newDiscountId,
            discountObject["discount-details"][languages[i]]
          );
        }
      });
    },
    updateDiscount(discountId, discountObject) {
      Discounts.partialUpdate(discountId, discountObject).then(() => {
        DiscountDetails.get(discountObject["id"]).then(res => {
          var languages = Object.keys(discountObject["discount-details"]);
          if (res.status == 200 && res.data) {
            for (var i = 0; i < languages.length; i++) {
              var tempDiscountDetailsObject = res.data.find(
                x =>
                  x["language"] ==
                    discountObject["discount-details"][languages[i]].code &&
                  x["discount-id"] == discountObject["id"]
              );
              if (tempDiscountDetailsObject) {
                this.updateDiscountDetails(
                  tempDiscountDetailsObject["id"],
                  discountObject["discount-details"][languages[i]]
                );
              } else {
                this.insertDiscountDetails(
                  discountObject["id"],
                  discountObject["discount-details"][languages[i]]
                );
              }
            }
          } else {
            for (var j = 0; j < languages.length; j++) {
              this.insertDiscountDetails(
                discountObject["id"],
                discountObject["discount-details"][languages[j]]
              );
            }
          }
        });
      });
    },
    /************  DISCOUNTS DETAILS ************/
    insertDiscountDetails(discountId, discountDetailObject) {
      DiscountDetails.add(discountId, {
        language: discountDetailObject.code,
        description: discountDetailObject.description,
        archived: false
      }).then();
    },
    updateDiscountDetails(discountDetailsId, discountDetailObject) {
      DiscountDetails.partialUpdate(discountDetailsId, {
        language: discountDetailObject.code,
        description: discountDetailObject.description,
        archived: false
      }).then();
    },
    /************  GROUP OF DISCOUNT  ************/
    insertNewGroupOfDiscount(campaignId, groupOfDiscount) {
      if (groupOfDiscount && campaignId) {
        GroupsOfDiscounts.add(campaignId, groupOfDiscount).then(res => {
          let locationSplit = res.headers.location.split("/");
          var newgroupOfDiscountId = locationSplit[locationSplit.length - 1];
          for (let i = 0; i < groupOfDiscount.discounts.length; i++) {
            if (groupOfDiscount.discounts[i]["discount-type"] == 1)
              groupOfDiscount.discounts[i]["discount-value"] =
                groupOfDiscount.discounts[i]["discount-value"] * 100;
            this.insertDiscount(
              newgroupOfDiscountId,
              groupOfDiscount.discounts[i]
            );
          }
          Campaigns.partialUpdate(campaignId, { status: 1 }).then(res => {
            if (res.status == 204) {
              this.$router.push({
                name: "allCampaigns",
                params: { campaignType: "active" }
              });
            }
          });
        });
      }
    },
    updateGroupOfDiscount(campaignId, groupOfDiscount) {
      if (groupOfDiscount && campaignId) {
        GroupsOfDiscounts.partialUpdate(
          groupOfDiscount.id,
          groupOfDiscount
        ).then(res => {
          if (res.status == 204) {
            for (let i = 0; i < groupOfDiscount.discounts.length; i++) {
              Discounts.get(groupOfDiscount.id).then(res => {
                if (res.status == 200) {
                  if (groupOfDiscount.discounts[i]["discount-type"] == 1)
                    groupOfDiscount.discounts[i]["discount-value"] =
                      groupOfDiscount.discounts[i]["discount-value"] * 100;
                  var tempDiscountObject = res.data.find(
                    x =>
                      x["product-id"] ==
                      groupOfDiscount.discounts[i]["product-id"]
                  );
                  if (tempDiscountObject) {
                    groupOfDiscount.discounts[i]["id"] = tempDiscountObject.id;
                    this.updateDiscount(
                      tempDiscountObject.id,
                      groupOfDiscount.discounts[i]
                    );
                  } else {
                    this.insertDiscount(
                      groupOfDiscount.id,
                      groupOfDiscount.discounts[i]
                    );
                  }
                }
              });
            }
            Campaigns.partialUpdate(campaignId, { status: 1 }).then(() => {
              this.$router.push({
                name: "allCampaigns",
                params: { campaignType: "active" }
              });
            });
          }
        });
      }
    }
  }
};
</script>